/*
   ****** The below React component is developed by AECS Private Limited. ******
   Please don't remove, replace, or edit this header information
   Component: <Alarms.js>
   Description: This React component handles the display of all users. Editable, adding new user, test sms and email.
   Dependencies: This component uses Material-UI components, moment for date formatting, and custom components like Header, Footer, and Sidebar.
*/
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import '../css/Map.css';
import { ContentContainer, MainContent, CenteredCard, StyledTableHead, StyledTableCell, StyledTable, RefreshIcon, CustomTextField, CustomButton, HeaderTitle } from '../Styles/User';
import CardContent from '@mui/material/CardContent';
import { IconButton, Alert } from '@mui/material';
import refreshIcon from '../Images/refresh-icon.svg';
import Grid from '@mui/material/Grid';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import PhoneIcon from '@mui/icons-material/Phone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import Switch from '@mui/material/Switch';
import {
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Checkbox,
} from '@mui/material';
import { Clear as ClearIcon, Edit as EditIcon, Delete as DeleteIcon, Save as SaveIcon } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Box } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import EmailIcon from '@mui/icons-material/Email';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Modal } from '@mui/material';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useLogoTitle } from '../classes/LogoTitleContext';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Header from '../Parts/Header';
import Footer from '../Parts/Footer';
import Sidebar from '../Parts/Sidebar';
import OutboxIcon from '@mui/icons-material/Outbox';
import SmsIcon from '@mui/icons-material/Sms';
import BuildIcon from '@mui/icons-material/Build';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import CancelIcon from '@mui/icons-material/Cancel';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';

const TestEmailSmsModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [sms, setSms] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [smsSent, setSmsSent] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [smsError, setSmsError] = useState(false);


  const handleSendTestEmail = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await fetch(`${API_ENDPOINTS.sendTestEmail}`, {
        method: 'POST',
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      if (response.ok) {
        setEmailSent(true);
        setEmailError(false);
      } else {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setEmailSent(false);
      setEmailError(true);
    }
  };

  const handleSendTestSMS = async () => {
    try {
      const authHeaders = getAuthHeaders();
      const response = await fetch(`${API_ENDPOINTS.sendTestSMS}`, {
        method: 'POST',
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phoneNumber, message }),
      });

      if (response.ok) {
        const data = await response.json();
        setSmsSent(true);
        setSmsError(false);
        //console.log('SMS sent successfully:', data.message);
      } else {
        const errorData = await response.json();
        console.error('Failed to send SMS:', errorData);
        setSmsSent(false);
        setSmsError(true);
        // Show the error message received from the server
        alert(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error sending SMS:', error);
      setSmsSent(false);
      setSmsError(true);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '500px', overflowY: 'auto', maxWidth: '350px', margin: '10% auto 0', backgroundColor: 'white', padding: '20px' }}>
        <IconButton onClick={onClose} style={{ alignSelf: 'flex-end' }}>
          <CloseIcon />
        </IconButton>
        <TextField
          label="Test Email"
          variant="outlined"
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: '10px' }}
        />
        <Button variant="contained" color="primary" onClick={handleSendTestEmail} style={{ marginBottom: '10px' }}>
          Send Test Email
        </Button>
        {emailSent && <Alert severity="success" style={{ marginBottom: '10px' }}>Email sent successfully!</Alert>}
        {emailError && <Alert severity="error" style={{ marginBottom: '10px' }}>Issue encountered while sending the test email. Please contact Service/Support team for assistance.</Alert>}
        <TextField
          label="Phone Number"
          variant="outlined"
          size="small"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          style={{ marginBottom: '10px' }}
        />
        <TextField
          label="Message"
          variant="outlined"
          size="small"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ marginBottom: '10px' }}
        />
        <Button variant="contained" color="primary" onClick={handleSendTestSMS} style={{ marginBottom: '10px' }}>
          Send Test SMS
        </Button>
        {smsSent && <Alert severity="success" style={{ marginBottom: '10px' }}>SMS sent successfully!</Alert>}
        {smsError && <Alert severity="error" style={{ marginBottom: '10px' }}>Issue encountered while sending the test SMS. Please contact Service/Support team for assistance.</Alert>}
      </div>
    </Modal>
  );
};

const AddUserModal = ({ isOpen, onClose, onSubmit, onInputChange, userData, onSelectChange, loggedInUser, confirmPassword, setConfirmPassword }) => (
  <Modal open={isOpen} onClose={onClose}>
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
      <div style={{ display: 'flex', flexDirection: 'column', maxHeight: '590px', overflowY: 'auto', maxWidth: '350px', margin: '10% auto 0', backgroundColor: 'white', padding: '20px' }}>

        {/* Header with CloseIcon and InfoIcon */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
          {/* Left Section: Add New User and Info Icon */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold' }}>Add New User</h3>
            <Tooltip
              title={
                <div style={{ fontSize: '12px', padding: '15px', color: '#333', lineHeight: '1.6', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
                  <strong style={{ fontSize: '14px', color: '#1976D2', display: 'block', marginBottom: '10px' }}>Instructions for Adding Users:</strong>
                  <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <PersonIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Your Name: Please enter your full name without any characters.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <PersonIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Role: Please select account role.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <LockIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Password: Choose a strong password.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <EmailIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Email: Enter a valid email address.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <PhoneIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Contact: Include a valid phone number.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <NotificationsActiveIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>Email Notifications: Enable or disable by selecting 'Yes' or 'No'.</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <SmsIcon style={{ color: '#1976D2', marginRight: '10px' }} />
                      <span>SMS Notifications: Enable or disable by selecting 'Yes' or 'No'.</span>
                    </li>
                  </ul>
                </div>
              }
            >
              <IconButton>
                <InfoIcon style={{ color: '#1976D2' }} />
              </IconButton>
            </Tooltip>
          </div>

          {/* Right Section: Close Icon */}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        {/* Form Fields */}
        <TextField
          label="Your Name"
          variant="outlined"
          size="small"
          name="username"
          type="username"
          value={userData.username}
          onChange={onInputChange}
          style={{ marginBottom: '10px' }}
          required
        />
        <TextField
          label="Password"
          variant="outlined"
          size="small"
          name="password"
          type="password"
          value={userData.password}
          onChange={onInputChange}
          style={{ marginBottom: '10px' }}
          required
        />
        <TextField
          label="Confirm Password"
          variant="outlined"
          size="small"
          type="password"
          value={confirmPassword} // Use local state for confirm password
          onChange={(e) => setConfirmPassword(e.target.value)} // Update local state
          style={{ marginBottom: '10px' }}
          required
        />
        <FormControl variant="outlined" size="small" style={{ marginBottom: '10px', minWidth: 120 }} required>
          <InputLabel>Role</InputLabel>
          <Select
            name="RoleID" // Bind to RoleID
            value={userData.RoleID || ''} // Ensure the value is not undefined, set it to '' if RoleID is undefined
            onChange={onInputChange} // Update RoleID on change
            label="Role"
          >
            {loggedInUser?.RoleID === 2 || loggedInUser?.RoleID === 1 ? (
              [
                <MenuItem key="admin" value="3">Admin</MenuItem>,
                <MenuItem key="user" value="4">User</MenuItem>
              ]
            ) : loggedInUser?.RoleID === 3 ? (
              [
                <MenuItem key="admin" value="3">Admin</MenuItem>,
                <MenuItem key="user" value="4">User</MenuItem>
              ]
            ) : loggedInUser?.RoleID === 4 ? (
              <MenuItem key="user" value="4">User</MenuItem>
            ) : null}

          </Select>
        </FormControl>
        <TextField
          label="Email"
          variant="outlined"
          size="small"
          name="email"
          type="email"
          value={userData.email}
          onChange={onInputChange}
          style={{ marginBottom: '10px' }}
          required
        />
        <TextField
          label="Contact"
          variant="outlined"
          size="small"
          name="contact"
          type="contact"
          value={userData.contact}
          onChange={onInputChange}
          style={{ marginBottom: '10px' }}
        />
        <FormControl variant="outlined" size="small" style={{ marginBottom: '10px', minWidth: 120 }} required>
          <InputLabel>Email enabled</InputLabel>
          <Select
            name="emailEnabled"
            value={userData.emailEnabled}
            onChange={onInputChange}
            label="Email enabled"
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" style={{ marginBottom: '10px', minWidth: 120 }} required>
          <InputLabel>SMS enabled</InputLabel>
          <Select
            name="smsEnabled"
            value={userData.smsEnabled}
            onChange={onInputChange}
            label="SMS enabled"
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>

        {/* Buttons */}
        <Button type="submit" variant="contained" color="primary" style={{ marginBottom: '10px' }}>
          Submit
        </Button>
        <Button variant="contained" onClick={onClose} style={{ marginBottom: '10px' }}>
          Cancel
        </Button>
      </div>
    </form>
  </Modal>
);

const User = ({ onLogout, loggedInUser, userData }) => {
  // eslint-disable-next-line
  const navigate = useNavigate();
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // eslint-disable-next-line
  const [isLoggedIn, setIsLoggedIn] = useState();
  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  const [isAddUserModalOpen, setAddUserModalOpen] = useState(false);
  // eslint-disable-next-line
  const [isAddUserFormOpen, setAddUserFormOpen] = useState(false);
  // eslint-disable-next-line
  const { logoUrl, projectTitle } = useLogoTitle();
  // eslint-disable-next-line
  const [anchorEl, setAnchorEl] = useState(null);
  const [username, setUsername] = useState();
  const [userRole, setUserRole] = useState('');
  const [isTestEmailSmsModalOpen, setTestEmailSmsModalOpen] = useState(false);
  const [projectUsers, setProjectUsers] = useState([]);
  const [editUserData, setEditUserData] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [editingUsers, setEditingUsers] = useState({});
  const [confirmPassword, setConfirmPassword] = useState('');

  const [newUserData, setNewUserData] = useState({
    username: '',
    password: '',
    email: '',
    RoleID: '',
    contact: '',
    emailEnabled: '',
    smsEnabled: '',
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const inputValue = type === 'checkbox' ? checked : value;
    setNewUserData({
      ...newUserData,
      [name]: inputValue,
    });
  };

  const handleTestEmailSmsClick = () => {
    setTestEmailSmsModalOpen(true);
  };

  const [users, setUsers] = useState([]);

  const handleAddUserSubmit = async () => {
    try {
      //console.log('Submitting new user data:', newUserData);
      //console.log('Password:', newUserData.password);
      //console.log('Confirm Password:', confirmPassword);

      if (newUserData.password !== confirmPassword) {
        alert('Passwords do not match. Please try again.');
        return;
      }

      if (!newUserData.username) {
        alert('Username cannot be empty.');
        return;
      }
      const authHeaders = getAuthHeaders();
      const response = await fetch(`${API_ENDPOINTS.AddUser}?Customerid=${loggedInUser.customerID}&project_description=${loggedInUser.project_description}&clientId=${loggedInUser.clientId}`, {
        method: 'POST',
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...newUserData,
          clientId: loggedInUser.clientid,
          title: loggedInUser.title,
        }),
      });
      if (response.ok) {
        const data = await response.json();
        //console.log('User added successfully:', data);
        setUsers((prevUsers) => [...prevUsers, data]);
        toast.success('User added successfully');
        setAddUserModalOpen(false);
      } else {
        const errorData = await response.json();
        if (errorData.message === 'Email ID already registered. Please contact support team.') {
          // Show specific error message if email is already registered
          toast.error('Email ID already registered. Please contact support team.');
        } else {
          // Handle other errors
          toast.error('Failed to add user. Please try again.');
        }
      }
    } catch (error) {
      console.error('Error adding user:', error);
      //toast.error('Error adding user. Please try again.');
    }
    setNewUserData({
      username: '',
      password: '',
      email: '',
      RoleID: '',
      contact: '',
      emailEnabled: '',
      smsEnabled: '',
    });

    setAddUserModalOpen(false);
  };
  const handleAddUserFormClose = () => {
    setAddUserFormOpen(false);
  };
  const handleAddUserClick = () => {
    setAddUserModalOpen(true);
  };
  const handleAddUserModalClose = () => {
    setAddUserModalOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
  };

  const filteredUsers = projectUsers.filter((user) =>
    user.username.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSaveUser = async (user) => {
    try {
      // Log the start of the save process and user data being sent
      {/*
      console.log('Saving user with data:', {
        roleID: user.roleID,
        email: user.email,
        contact: user.contact,
        emailEnabled: user.emailEnabled,
        smsEnabled: user.smsEnabled,
      });
    */}
      const authHeaders = getAuthHeaders();

      // Log the headers being sent
      //console.log('Authentication headers:', authHeaders);

      const response = await fetch(`${API_ENDPOINTS.ProjectUsersGet}/ProjectUsers/${user.username}`, {
        method: 'PUT',
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          roleID: user.roleID,
          email: user.email,
          contact: user.contact,
          emailEnabled: user.emailEnabled,
          smsEnabled: user.smsEnabled,
          clientId: loggedInUser.clientId,
        }),
      });

      // Log the response status and its result
      //console.log('Response status:', response.status);

      if (response.ok) {
        //console.log('User updated successfully');
        toast.success('User updated successfully');

        // Remove the user from the editing state
        setEditingUsers((prev) => {
          const updated = { ...prev };
          delete updated[user.username]; // Remove the user from editing
          return updated;
        });

        // Reset edit user data
        setEditUserData((prev) => {
          const updated = { ...prev };
          delete updated[user.username]; // Clear the edited data
          return updated;
        });

        fetchProjectUsers(); // Optionally, refetch the list of users after update
      } else {
        console.error('Failed to update user. Response:', await response.json());
        toast.error('Failed to update user');
      }
    } catch (error) {
      // Log the error if there’s an issue with the fetch
      console.error('Error updating user:', error);
      toast.error('Error updating user');
    }
  };

  const handleEditUser = (user) => {
    setEditUserData({
      ...editUserData,
      [user.username]: {
        ...user,
        roleID: user.RoleID,
        email: user.email,
        contact: user.Contact,
        emailEnabled: user.EmailEnabled,
        smsEnabled: user.SmsEnabled,
      },
    });

    // Mark user as in editing mode
    setEditingUsers((prev) => ({
      ...prev,
      [user.username]: true,
    }));
  };

  const handleCancelEdit = (username) => {
    // Reset the edited data and stop editing the user
    setEditUserData((prev) => {
      const updated = { ...prev };
      delete updated[username]; // Clear the edited data for that user
      return updated;
    });

    // Remove the user from the editing mode
    setEditingUsers((prev) => {
      const updated = { ...prev };
      delete updated[username]; // Stop editing the user
      return updated;
    });
  };

  const handleDeleteUser = async (username) => {
    try {
      const response = await fetch(`${API_ENDPOINTS.DeleteUser}/ProjectUsers/${username}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        toast.success('User deleted successfully');
        fetchProjectUsers();
      } else {
        toast.error('Failed to delete user');
      }
    } catch (error) {
      //toast.error('Error deleting user');
    }
  };

  const fetchProjectUsers = async () => {
    try {

      const response = await axios.get(`${API_ENDPOINTS.ProjectUsersGet}/ProjectUsers?Customerid=${loggedInUser?.customerID}&ProjectsAssigned=${loggedInUser?.ProjectsAssigned}&ClientId=${loggedInUser.clientId}`);

      console.log('Fetched Project Users:', response.data);

      let filteredUsers;

      // If RoleID is 1, show all users
      if (loggedInUser?.RoleID === 1) {
        filteredUsers = response.data;
      } else {
        // Filter users based on loggedInUser RoleID
        filteredUsers = response.data.filter(user => {
          if (loggedInUser?.RoleID === 4) {
            return user.RoleID === 4;
          } else if (loggedInUser?.RoleID === 3) {
            return user.RoleID === 3 || user.RoleID === 4 || user.RoleID === null;
          } else if (loggedInUser?.RoleID === 2) {
            return user.RoleID === 2 || user.RoleID === 3 || user.RoleID === 4;
          }
          return false;
        });
      }
      setProjectUsers(filteredUsers);
    } catch (error) {
      console.error('Error fetching project users:', error);
      // Handle error
    }
  };

  useEffect(() => {
    if (loggedInUser?.customerID) {
      fetchProjectUsers();
    }
    //console.log('Logged In User:', loggedInUser);
    //console.log('Customer ID:', loggedInUser?.customerID);
  }, [loggedInUser]);

  // eslint-disable-next-line
  const LogoutIcon = styled(PowerSettingsNewIcon)({
    marginRight: '8px',
  });

  // eslint-disable-next-line
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setUsername(loggedInUser?.username || '');
    setUserRole(loggedInUser?.userRole || '');
  };

  const roleMapping = {
    1: 'Super Admin',
    2: 'Admin_M',
    3: 'Admin',
    4: 'User',
  };

  const getFilteredRoles = (roleID) => {
    switch (roleID) {
      case 1:
        return roleMapping; // Show all roles
      case 2:
        return Object.fromEntries(
          Object.entries(roleMapping).filter(([key]) => key === '2' || key === '3')
        ); // Show Admin and User
      case 3:
        return Object.fromEntries(
          Object.entries(roleMapping).filter(([key]) => key === '3')
        ); // Show only User
      default:
        return {};
    }
  };

  return (
    <div style={{ backgroundColor: '#EBEFF3' }}>
      <Sidebar loggedInUser={loggedInUser} />
      <Header
        logoUrl={logoUrl}
        loggedInUser={loggedInUser}
        onLogout={onLogout}
        username={username}
        userRole={userRole}
      />
      <ContentContainer>
        <MainContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} lg={20}>
              <CenteredCard>
                <CardContent>
                  <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                      <TextField
                        label="Search by username"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={searchQuery}
                        onChange={handleSearchChange}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={handleClearSearch}>
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          marginBottom: '10px',
                          width: { xs: '100%', sm: '70%', md: '50%', lg: '17%' }, // Responsive width
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: 'primary.main',
                            },
                            '&:hover fieldset': {
                              borderColor: 'primary.main',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: 'primary.main',
                            },
                          },
                          '& .MuiInputLabel-root': {
                            color: 'primary.main',
                            '&.Mui-focused': {
                              color: 'primary.main',
                            },
                          },
                        }}
                      />
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap' }}>
                        <CustomButton onClick={handleAddUserClick} startIcon={<AddIcon />}>
                          Add User
                        </CustomButton>
                        <CustomButton onClick={handleTestEmailSmsClick}>
                          Test Email & SMS
                        </CustomButton>
                        <RefreshIcon
                          title="Refresh"
                          src={refreshIcon}
                          label="Click to refresh"
                          alt="Refresh"
                          onClick={() => window.location.reload()}
                          sx={{ cursor: 'pointer' }} // Adding pointer cursor for better UX
                        />
                      </Box>
                    </div>
                    <TestEmailSmsModal isOpen={isTestEmailSmsModalOpen} onClose={() => setTestEmailSmsModalOpen(false)} />
                  </div>

                  <AddUserModal
                    isOpen={isAddUserModalOpen}
                    onClose={() => setAddUserModalOpen(false)}
                    onSubmit={handleAddUserSubmit}
                    onInputChange={handleInputChange}
                    userData={newUserData}
                    loggedInUser={loggedInUser}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                  />
                  <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableHead align="center" style={{ width: '10%' }}>
                            User Name
                          </StyledTableHead>
                          {/*<StyledTableHead align="center" style={{ width: '7%' }}>
                            Password
                          </StyledTableHead>*/}
                          <StyledTableHead align="center" style={{ width: '10%' }}>
                            Role
                          </StyledTableHead>
                          <StyledTableHead align="center" style={{ width: '15%' }}>
                            Email Id
                          </StyledTableHead>
                          <StyledTableHead align="center" style={{ width: '10%' }}>
                            Mobile Number
                          </StyledTableHead>
                          <StyledTableHead align="center" style={{ width: '8%' }}>
                            Email Alert
                          </StyledTableHead>
                          <StyledTableHead align="center" style={{ width: '6%' }}>
                            SMS Alert
                          </StyledTableHead>
                          <StyledTableHead align="center" style={{ width: '12%' }}>
                            Action
                          </StyledTableHead>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredUsers.map((user) => (
                          <TableRow key={user.username}>
                            <TableCell align="center">
                              {user.username}  {/* Display User Name */}
                            </TableCell>

                            {/* Editable Role */}
                            <TableCell align="center">
                              {roleMapping[user.RoleID] || 'Null'}
                            </TableCell>

                            {/* Editable Email */}
                            <TableCell align="center">
                              {user.email}
                            </TableCell>

                            {/* Editable Mobile Number */}
                            <TableCell align="center">
                              {editUserData[user.username] ? (
                                <TextField
                                  value={editUserData[user.username].contact}
                                  onChange={(e) => setEditUserData({
                                    ...editUserData,
                                    [user.username]: {
                                      ...editUserData[user.username],
                                      contact: e.target.value,
                                    },
                                  })}
                                />
                              ) : (
                                user.Contact
                              )}
                            </TableCell>

                            {/* Editable Email Alert */}
                            <TableCell align="center">
                              {editUserData[user.username] ? (
                                <Switch
                                  checked={editUserData[user.username].emailEnabled}
                                  onChange={(e) => setEditUserData({
                                    ...editUserData,
                                    [user.username]: {
                                      ...editUserData[user.username],
                                      emailEnabled: e.target.checked,
                                    },
                                  })}
                                />
                              ) : (
                                user.EmailEnabled ? 'Yes' : 'No'
                              )}
                            </TableCell>

                            {/* Editable SMS Alert */}
                            <TableCell align="center">
                              {editUserData[user.username] ? (
                                <Switch
                                  checked={editUserData[user.username].smsEnabled}
                                  onChange={(e) => setEditUserData({
                                    ...editUserData,
                                    [user.username]: {
                                      ...editUserData[user.username],
                                      smsEnabled: e.target.checked,
                                    },
                                  })}
                                />
                              ) : (
                                user.SmsEnabled ? 'Yes' : 'No'
                              )}
                            </TableCell>

                            {/* Action Buttons: Edit, Save, Delete */}
                            <TableCell align="center">
                              {editingUsers[user.username] ? (
                                <>
                                  <Tooltip title="Save">
                                    <IconButton color="primary" onClick={() => handleSaveUser(editUserData[user.username])} disabled={user.RoleID === 1}>
                                      <SaveIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Cancel">
                                    <IconButton color="secondary" onClick={() => handleCancelEdit(user.username)} disabled={user.RoleID === 1}>
                                      <CancelIcon />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              ) : (
                                <>
                                  <Tooltip title="Edit">
                                    <IconButton color="primary" onClick={() => handleEditUser(user)} disabled={user.RoleID === 1}>
                                      <EditIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <IconButton color="primary" onClick={() => handleDeleteUser(user.username)} disabled={user.RoleID === 1}>
                                      <DeleteIcon />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            </TableCell>

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </CardContent>
              </CenteredCard>
            </Grid>
          </Grid>
        </MainContent>
      </ContentContainer>
      <Footer />
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
      <ToastContainer />
    </div>
  );
};

export default User;